module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "hidden-form"
  }, [_c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.inputConfirmed.apply(null, arguments)
      }
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.input),
      expression: "input"
    }],
    ref: "hiddenInputField",
    attrs: {
      "type": "text",
      "disabled": _vm.disabled
    },
    domProps: {
      "value": (_vm.input)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.input = $event.target.value
      }
    }
  })])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-ad0ba558!./~/vue-loader/lib/selector.js?type=template&index=0!./app/components/HiddenInput.vue
// module id = 1109
// module chunks = 0